import { findDocumentos } from "@redux/slices/documentos"
import { useDispatch, useSelector } from "@redux/store"
import { CSS_HELPERS, THEME_COLORS } from "@theme/constants"
import { Col, Row, Button } from "antd"
import Modal from "antd/lib/modal/Modal"
import _ from "lodash"
import Link from "next/link"
import { useEffect, useState } from "react"
import { IoCloseCircle } from "react-icons/io5"
import { VscEye } from "react-icons/vsc"

import styled from "styled-components"






const AdjuntosProfile = ({ filter }) => {
    const [current, setCurrent] = useState();

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(findDocumentos());
    }, [dispatch]);

    const { documentosByCat } = useSelector(item => item.documentos);


    const handleToggle = () => setCurrent(!current);

    return (
        <>
            <Row gutter={[16, 9]}>
                {
                    documentosByCat[filter] &&
                    documentosByCat[filter].map(item => {
                        return (
                            <Col xs={24} sm={24} md={24} key={item.id}>
                                <EdocCard >
                                    <Row>
                                        <Col xs={20} sm={21} md={21} className="text_side">

                                            <p>{item.titulo} </p>
                                            <div className="link_side">
                                                <Link href={item.url} target="_blank"
                                                    passHref
                                                    rel="noopener noreferrer"
                                                >
                                                    Descargar
                                                </Link>
                                                {/* <FaRegCopy /> */}
                                            </div>
                                        </Col>
                                        <Col xs={4} sm={3} md={3} className="icon_side">
                                            <div
                                                onClick={() => setCurrent(item)}
                                                role='button'
                                                aria-pressed="false"
                                                tabIndex="0">
                                                <VscEye />
                                            </div>
                                        </Col>
                                    </Row>
                                </EdocCard>
                            </Col>
                        )
                    })}
            </Row>

            <Modal
                width={'100%'}
                centered
                visible={current}
                onOk={() => { }}
                onCancel={handleToggle}
                footer={false}
                bodyStyle={{ boxShadow: 'none' }}
                style={{ borderRadius: "9pt", overflow: 'hidden', paddingBottom: 0, marginBottom: 0 }}
                closeIcon={
                    <div style={{ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <IoCloseCircle size="2.1em" />
                    </div>
                }>
                {current && current.url &&
                    <>
                        <FrameView>
                            <iframe src={current.url}  ></iframe>
                        </FrameView>

                        <Button block href={current.url} target="_blank" style={{ marginTop: '1em' }}>
                            Descargar
                        </Button>
                    </>

                }
            </Modal>

        </>

    )
}

export default AdjuntosProfile;

const FrameView = styled.div`
    height: 65vh;
    iframe {
        border: 0;
        height: 100%;
        width: 100%;
    }
`
const EdocCard = styled.div`
    ${CSS_HELPERS.BOX_SHADOW};
    border-radius:${CSS_HELPERS.RADIUS};
    overflow:hidden;
    background-color: ${THEME_COLORS.light.bg.main};
    cursor: pointer;
   


    .icon_side{
        display: flex;
        flex-direction:column;
        justify-content:center;
        align-items:center;
        background:${THEME_COLORS.light.secondary.main};
        svg{
            font-size:3em;
            color:${THEME_COLORS.light.secondary.contrastText};
        }
    };
    
    .text_side{
        /* background:yellow; */

        padding:1em;
        display: flex;
        flex-direction:column;
        gap: 0.9em;
        p {
            font-size: 1em;
            color: ${THEME_COLORS.light.primary.alt};
        }
        .link_side{
            display:flex;
            align-items:center;
            gap: 0.6em;
            svg{
                font-size: 1.5em;
                color: ${THEME_COLORS.light.primary.main};

            }
            a {
                font-size: 1em;
                color: ${THEME_COLORS.light.primary.main};
            }
          
        }
        
    }

  
  
`